<template>
  <span>
    <span>添付ファイル一覧</span>
    <table
      class="unstriped boss-table pega-mb-20"
    >
      <thead>
        <tr>
          <th class="boss-table-head-center">
            ファイル名
          </th>
          <th class="boss-table-head-center">
            送信日時
          </th>
          <th class="boss-table-head-center">
            閲覧期限
            <span
              v-tooltip="{ content: '応募者がマイページ上でファイルを閲覧できる期限。これを過ぎると閲覧できなくなります。'}"
              class="pega-circle"
            >?
            </span>
          </th>
          <th class="boss-table-head-center pega-file-operation">
            操作メニュー
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-if="summaryFiles.length">
          <template v-for="(summaryFile, i) in summaryFiles">
            <applicant-message-attachment-file
              :key="i"
              :entry-id="entryId"
              :summary-file="summaryFile"
              @fetchAllMessage="$emit('fetchAllMessage')"
            />
          </template>
        </template>
        <tr v-else>
          <td
            colspan="4"
            data-test="no-file"
            class="text-center boss-text"
          >
            送信したファイルはありません。
          </td>
        </tr>
      </tbody>
    </table>
  </span>
</template>

<script>
import ApplicantMessageAttachmentFile from '@/components/molecules/ApplicantMessageAttachmentFile'

export default {
  components: {
    ApplicantMessageAttachmentFile
  },
  props: {
    summaryFiles: {
      type: Array,
      default: () => []
    },
    entryId: {
      type: Number,
      required: true
    }
  }
}
</script>
